import * as React from 'react';
import { AutocompletePicker } from 'app/components/BasicPickers/AutocompletePicker';

export function TypePicker(props) {
  return (
    <AutocompletePicker
      loadData={() =>
        Promise.resolve(['.xlsx', '.csv'].map(s => ({ Id: s, Name: s })))
      }
      variant="filled"
      fullWidth
      {...props}
    />
  );
}
